import { css } from "@emotion/react"

import { fontsCP, colorsCP } from "../../Tokens"

export const iqBtn = css`button.iq-btn {
  font-family: ${fontsCP["font-primary"]["font-family"]};
  font-size: 16px;
  line-height: 1.5;
  border-radius: 32px;
  padding: 10px;
  height: 48px;
  background-color: ${colorsCP["blue-40"]};
  border: 1px solid ${colorsCP["blue-40"]};
  color: ${colorsCP["neutral-00"]};
  transition: all .2s ease-in-out;

  // Secondary button
  &--type-secondary {
    background: none;
    border-color: ${colorsCP["blue-40"]};
    padding: 12px 24px;
    color: ${colorsCP["blue-40"]};
    transition: all .2s ease-in-out;

    &:active {
      background: none;
      border-color: ${colorsCP["blue-60"]};
      color: ${colorsCP["neutral-00"]};
    }
  }

  &--type-secondary:hover {
    border-color: ${colorsCP["blue-40"]};
    background-color: ${colorsCP["blue-40"]};
    color: ${colorsCP["neutral-00"]};
    transition: all .2s ease-in-out
  }

  // Secondary disabled
  &--type-secondary&--disabled {
    &, &:hover, &:active {
      border-color: ${colorsCP["neutral-50"]};
      color: ${colorsCP["neutral-50"]};
    }
  }

  // Type text default
  &--type-text {
    background: none;
    border: none;
    font-family: ${fontsCP["font-primary"]["font-family"]};
    font-weight: 300;
    line-height: 1.5;
    color: ${colorsCP["neutral-70"]};
    transition: all .2s ease-in-out

    +aboveMedium() {
      position: relative;

      &:before {
        display: block;
        content: attr(title);
        font-weight: 700;
        height: 0;
        overflow: hidden;
        visibility: hidden;
      }
    }

    .iq-btn__text {
      +aboveMedium() {
        position: absolute;
      }
    }

    &:hover {
      background: none;
      border: none;
      color: ${colorsCP["neutral-70"]};
      font-weight: 700;
      transition: all .2s ease-in-out
    }

    &:active {
      background: none;
      border: none;
      color: ${colorsCP["blue-40"]};
      font-weight: 700;
    }
  }

  &--active {
    color: ${colorsCP["blue-40"]};
    font-weight: 700;
  }

  &--loading, &--type-secondary&--loading, &--type-text&--loading {
    background-color: ${colorsCP["blue-40"]};
    border-color: ${colorsCP["blue-40"]};
  }

  .iq-btn__loading-spinner {
    background-image: linear-gradient(to bottom, blue-30 40%, ${colorsCP["blue-40"]});

    &:after {
      background-color: ${colorsCP["blue-40"]};
    }
  }
}

.iq-btn:hover {
  background-color: ${colorsCP["blue-50"]};
  border-color: ${colorsCP["blue-50"]};
  color: ${colorsCP["neutral-00"]};
}

.iq-btn:active {
  background-color: ${colorsCP["blue-60"]};
  border-color: ${colorsCP["blue-60"]};
  color: ${colorsCP["neutral-00"]};
}

button.iq-btn--disabled {
  background-color: ${colorsCP["neutral-20"]};
  border-color: ${colorsCP["neutral-20"]};
  color: ${colorsCP["neutral-50"]};
}`
